<template>
    <div class="row">
      <div class="col-md-2 float-left">
        <div class="dropdown-parent-div">
          <ejs-dropdownlist
            id="dropdownlist"
            :dataSource="dropdownListFilter"
            :fields="fields"
            :index="dropdownIndex"
            class="c-drop-down"
            @change="dropdownSelectChange"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-md-8"></div>
      <div class="col-md-2 float-right"></div>
      <div class="col-12 mt-2">
        <audience-loader :isLoading="isLoading"></audience-loader>
        <ejs-grid
          id="associatedcampaignsgrid"
          ref="grid"
          :dataSource="gridData"
          class="cendyn-grid sortingenabled"
          :allow-paging="true"
          :allow-filtering="true"
          :allow-sorting="true"
          :enable-persistence="true"
          :page-settings="pageSettings"
          :data-bound="dataBound"
          :filterSettings="filterOptions"
          :dataStateChange="dataStateChange"
          :enableAutoFill="false"
        >
          <e-columns>
            <e-column
              field="projectId"
              headerText="Project ID"
              type="String"
              :filter="customFilter"
              :template="idTemplate"
            ></e-column>
            <e-column
              field="name"
              headerText="Campaign Name"
              type="String"
              width="20%"
            ></e-column>
            <e-column
              field="campaignType"
              headerText="Type"
              type="String"
              :allowFiltering="false"
              :allowSorting="false"
            ></e-column>
            <e-column
              field="status"
              headerText="Status"
              type="String"
              :filter="statusFilter"
            ></e-column>
            <e-column
              field="schedule"
              headerText="Schedule"
              type="String"
              :template="scheduleTemplate"
              :filter="scheduleFilter"
            ></e-column>
            <e-column
              field="createdOn"
              headerText="Created On"
              type="Date"
              :template="createdOnTemplate"
              :allowFiltering="false"
            ></e-column>
            <e-column
              field="modifiedOn"
              headerText="Updated On"
              type="Date"
              :template="updatedOnTemplate"
              :allowFiltering="false"
            ></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import { Sort, Page, Filter, GridPlugin } from '@syncfusion/ej2-vue-grids';
  import {
    DropDownListPlugin,
    MultiSelect,
    CheckBoxSelection,
  } from '@syncfusion/ej2-vue-dropdowns';
  import GridProjectId from '@/components/grid/GridProjectId.vue';
  import { mapGetters, mapState } from 'vuex';
  import { createElement } from '@syncfusion/ej2-base';
  import { TextBox } from '@syncfusion/ej2-inputs';
  import { DataManager } from '@syncfusion/ej2-data';
  import AudienceLoader from '@/components/AudienceLoader.vue';
  import AudienceScheduleTemplate from '@/components/grid/gridSchedule.vue';
  import AudienceCreatedOnTemplate from '@/components/grid/gridCreatedOn.vue';
  import AudienceUpdatedOnTemplate from '@/components/grid/gridUpdatedOn.vue';
  import Common from '../helper/Common';
  import * as $ from 'jquery';
  
  Vue.use(GridPlugin);
  Vue.use(DropDownListPlugin);
  MultiSelect.Inject(CheckBoxSelection);
  
  export default {
    components: { AudienceLoader },
    name: 'associatedcampaignsgrid',
    props: ['audienceId'],
    data() {
      return {
        isEmail: true,
        dropdownIndex: 0,
        isLoading: false,
        dropdownValue: 'email',
        dropdownListFilter: [{ text: 'Email', value: 'email' }],
        fields: { text: 'text', value: 'value' },
        gridData: new DataManager(),
        pageSettings: {
          pageCount: 5,
          pageSize: 10,
          pageSizes: ['10', '25', '50', '100'],
        },
        filterOptions: {
          type: 'Menu',
          mode: 'OnEnter',
          operators: {
            stringOperator: [
              { value: 'startsWith', text: 'Starts With' },
              { value: 'endsWith', text: 'Ends With' },
              { value: 'contains', text: 'Contains' },
              { value: 'equal', text: 'Equal' },
            ],
          },
        },
        customFilter: {
          ui: {
            create: (args) => {
              const flValInput = createElement('input', {
                className: 'flm-input',
              });
              args.target.appendChild(flValInput);
              this.dropInstance = new TextBox({
                placeholder: 'Enter the value',
              });
              this.dropInstance.appendTo(flValInput);
            },
            write: (args) => {
              if (args.filteredValue) {
                this.dropInstance.value = args.filteredValue;
              }
            },
            read: (args) => {
              args.fltrObj.filterByColumn(
                args.column.field,
                args.operator,
                this.dropInstance.value,
                false
              );
            },
          },
        },
        statusFilter: {
          ui: {
            create: (args) => {
              const flValInput = createElement('input', {
                className: 'flm-input',
              });
              args.target.appendChild(flValInput);
              if (args.target.parentElement.children) {
                args.target.parentElement.children[0].style.display = 'none';
                args.target.parentElement.children[1].style.paddingTop = '0px';
              }
              if (this.isEmail) {
                this.dropInstance = new MultiSelect({
                  dataSource: [
                    { statusCampaignTranslated: 'Approved' },
                    { statusCampaignTranslated: 'Draft' },
                    { statusCampaignTranslated: 'Pending' },
                    { statusCampaignTranslated: 'Rejected' },
                    { statusCampaignTranslated: 'Scheduled' },
                    { statusCampaignTranslated: 'Testing' },
                  ],
                  fields: {
                    text: 'statusCampaignTranslated',
                    value: 'statusCampaignTranslated',
                  },
                  placeholder: 'Select a value',
                  popupHeight: '200px',
                  mode: 'CheckBox',
                });
              } else {
                this.dropInstance = new MultiSelect({
                  dataSource: [
                    { statusCampaignTranslated: 'Approved' },
                    { statusCampaignTranslated: 'Draft' },
                    { statusCampaignTranslated: 'Pending' },
                    { statusCampaignTranslated: 'Rejected' },
                    { statusCampaignTranslated: 'Scheduled' },
                  ],
                  fields: {
                    text: 'statusCampaignTranslated',
                    value: 'statusCampaignTranslated',
                  },
                  placeholder: 'Select a value',
                  popupHeight: '200px',
                  mode: 'CheckBox',
                });
              }
              this.dropInstance.value = this.dropInstance.value || [];
              this.dropInstance.appendTo(flValInput);
            },
            write: (args) => {
              let arr = [];
              if (args.parent.filterModule.actualPredicate.status !== undefined) {
                arr = args.parent.filterModule.actualPredicate.status.map(
                  (element) => element.value
                );
              }
              this.dropInstance.value = Array.isArray(args.filteredValue)
                ? args.filteredValue
                : arr;
            },
            read: (args) => {
              args.fltrObj.filterSettings.columns =
                args.fltrObj.filterSettings.columns.filter(
                  (x) => x.field !== args.column.field
                );
              args.fltrObj.filterByColumn(
                args.column.field,
                args.operator,
                this.dropInstance.value
              );
            },
          },
        },
        scheduleFilter: {
          ui: {
            create: (args) => {
              const flValInput = createElement('input', {
                className: 'flm-input',
              });
              args.target.appendChild(flValInput);
              if (args.target.parentElement.children) {
                args.target.parentElement.children[0].style.display = 'none';
                args.target.parentElement.children[1].style.paddingTop = '0px';
              }
              this.dropInstance = new MultiSelect({
                dataSource: [
                  { scheduleStatus: 'Active' },
                  { scheduleStatus: 'Inactive' },
                  { scheduleStatus: 'Blank' },
                ],
                fields: {
                  text: 'scheduleStatus',
                  value: 'scheduleStatus',
                },
                placeholder: 'Select a value',
                popupHeight: '200px',
                mode: 'CheckBox',
              });
              this.dropInstance.value = this.dropInstance.value || [];
              this.dropInstance.appendTo(flValInput);
            },
            write: (args) => {
              let arr = [];
              if (
                args.parent.filterModule.actualPredicate.schedule !== undefined
              ) {
                arr = args.parent.filterModule.actualPredicate.schedule.map(
                  (element) => element.value
                );
              }
              this.dropInstance.value = Array.isArray(args.filteredValue)
                ? args.filteredValue
                : arr;
            },
            read: (args) => {
              args.fltrObj.filterSettings.columns =
                args.fltrObj.filterSettings.columns.filter(
                  (x) => x.field !== args.column.field
                );
              args.fltrObj.filterByColumn(
                args.column.field,
                args.operator,
                this.dropInstance.value
              );
            },
          },
        },
        idTemplate() {
          return {
            template: {
              extends: GridProjectId,
            },
          };
        },
        scheduleTemplate() {
          return {
            template: {
              extends: AudienceScheduleTemplate,
            },
          };
        },
        createdOnTemplate() {
          return {
            template: {
              extends: AudienceCreatedOnTemplate,
            },
          };
        },
        updatedOnTemplate() {
          return {
            template: {
              extends: AudienceUpdatedOnTemplate,
            },
          };
        },
      };
    },
    mounted() {
      Promise.all([this.fetchSalesDropdown()])
        .then((results) => {
          this.dropdownListFilter = this.dropdownListFilter.concat(...results);
        })
        .catch((error) => {
          console.error('API call error:', error);
        });
      this.loadAssociatedCampaignGrid('email');
    },
    computed: {
      ...mapGetters({
        clientId: 'counter/currentClientId',
      }),
    },
    created() {
      window.localStorage.removeItem('gridassociatedcampaignsgrid');
    },
    methods: {
      fetchSalesDropdown() {
        return new Promise((resolve) => {
          window.App.$axios
            .get(
              `/api/campaign/api/v1.0/settings/companyid/${this.clientId}/hassalesenabled?api_user=${window.eInsightUserEmail}`
            )
            .then((response) => {
              if (response.data === true) {
                resolve([{ text: 'Email (Sales)', value: 'sales' }]);
              } else {
                resolve([]);
              }
            });
        });
      },
      loadAssociatedCampaignGrid(campaignType) {
        const state = {
          action: {
            currentPage: 1,
          },
          skip: 0,
          take: 10,
        };
        this.initializeGridData(state, campaignType);
      },
      dataStateChange(args) {
        if (
          args.action.requestType !== 'stringfilterrequest' &&
          args.action.requestType !== 'refresh'
        ) {
          this.initializeGridData(args, this.dropdownValue);
        }
      },
      dataBound() {
        $('.e-emptyrow').find('td').text('');
        if (
          this.gridData !== undefined &&
          this.gridData.result !== undefined &&
          this.gridData.result.length === 0
        ) {
          $('.e-emptyrow').find('td').text('No records to display');
        }
      },
      dropdownSelectChange(args) {
        this.dropdownValue = args.itemData.value;
        this.$refs.grid.goToPage(1);
        this.$refs.grid.clearFiltering();
        this.$refs.grid.clearSorting();
        this.loadAssociatedCampaignGrid(this.dropdownValue);
      },
      encodeUrl(url) {
        return encodeURIComponent(url);
      },
      dataStateToQuery(dataState) {
        const query = [];
        const exportQuery = [];
        const defaultState = {
          action: {
            currentPage: 1,
          },
          skip: 0,
          take: 10,
        };
        const currentState = dataState || defaultState;
        const { action, take, sorted, where } = currentState;
  
        if (currentState) {
          const page = action.currentPage || 1;
          const pageSize = take || 10;
          query.push(`page=${page}`);
          query.push(`pagesize=${pageSize}`);
  
          if (sorted) {
            const sort = sorted[0];
            let column = sort.name;
            switch (sort.name.toLowerCase()) {
              case 'schedule':
                column = 'schedulestatus';
                break;
              case 'projectid':
                column = 'campaignid';
                break;
              case 'name':
                column = 'campaignname';
                break;
              default:
                column = sort.name;
            }
            const direction = sort.direction === 'descending' ? 'desc' : 'asc';
            query.push(`sortby=${direction}(${column.toLowerCase()})`);
            exportQuery.push(`sortby=${direction}(${column.toLowerCase()})`);
          }
          if (where) {
            const operations = {
              startswith: 'stw',
              endswith: 'edw',
              contains: 'cts',
              equals: 'eq',
              notequal: 'neq',
              greaterthan: 'gt',
              greaterthanorequal: 'gte',
              lessthan: 'lt',
              lessthanorequal: 'lte',
            };
  
            where[0].predicates.forEach((predicate) => {
              const operator = operations[predicate.operator] || 'eq';
              if (predicate.field) {
                switch (predicate.field) {
                  case 'status':
                    query.push(`status.cts=${predicate.value}`);
                    exportQuery.push(`status.cts=${predicate.value}`);
                    break;
                  case 'schedule':
                    query.push(`schedulestatus.cts=${predicate.value}`);
                    exportQuery.push(`schedulestatus.cts=${predicate.value}`);
                    break;
                  default:
                    query.push(
                      `${predicate.field.toLowerCase()}.${operator}=${
                        predicate.value
                      }`
                    );
                    exportQuery.push(
                      `${predicate.field.toLowerCase()}.${operator}=${
                        predicate.value
                      }`
                    );
                }
              } else if (predicate.predicates) {
                const filterPredicateArray = predicate.predicates;
  
                // If there is a predicate for email column, joining all the selected elements from dropdown and adding it to the dynamicQuery
                if (
                  filterPredicateArray
                    .map((predicate) => predicate.field === 'status')
                    .includes(true)
                ) {
                  const status = filterPredicateArray
                    .map((pred) => pred.value)
                    .join(',');
                  query.push(`status.cts=${status}`);
                  exportQuery.push(`status.cts=${status}`);
                }
  
                // If there is a predicate for schedule column, joining all the selected elements from dropdown and adding it to the dynamicQuery
                if (
                  filterPredicateArray
                    .map((predicate) => predicate.field === 'schedule')
                    .includes(true)
                ) {
                  const scheduleStatus = filterPredicateArray
                    .map((pred) => pred.value)
                    .join(',');
                  query.push(`scheduleStatus.cts=${scheduleStatus}`);
                  exportQuery.push(`scheduleStatus.cts=${scheduleStatus}`);
                }
              }
            });
          }
        } else {
          query.push('page=1');
          query.push('pagesize=10');
        }
  
        const dynamicQuery = query.join('&');
        const dynamicExportQuery = exportQuery.length
          ? exportQuery.join('&')
          : '';
        const queries = { dynamicQuery, dynamicExportQuery };
        return queries;
      },
      initializeGridData(state, campaignType) {
        this.isEmail = campaignType === 'messaging' ? false : true;
        const queries = this.dataStateToQuery(state);
        const dynamicQuery = this.encodeUrl(queries.dynamicQuery);
        this.isLoading = true;
  
        if (this.audienceId !== undefined) {
          window.App.$axios
            .get(
              `/api/audience/api/v1.0/companyid/${this.clientId}/audience/${this.audienceId}/campaigns/${campaignType}?dynamicQuery=${dynamicQuery}&api_user=${window.eInsightUserEmail}`
            )
            .then((response) => {
              const { audienceCampaigns, total } = response.data.data;
              let dataResult = {};
              if (audienceCampaigns.length === 0) {
                dataResult = {
                  result: [],
                  count: 0,
                };
              } else {
                dataResult = {
                  result: audienceCampaigns,
                  count: total,
                };
              }
              this.gridData = dataResult;
              this.isLoading = false;
            })
            .catch((error) => {
              // Catching any error any passing an empty dataResult to show no records results
              console.log(error);
              const dataResult = {
                result: [],
                count: 0,
              };
              this.gridData = dataResult;
              this.isLoading = false;
            });
        }
      },
    },
    provide: {
      grid: [Filter, Sort, Page],
    },
  };
  </script>
    
  <style lang='scss'>
  @import '../../public/legacy/criteria/css/scss/syncfusionGrid.scss';
  .btn.active:disabled {
    background: #111359;
    color: #ccc;
  }
  
  .e-btn.e-outline {
    border-color: #7e80cb;
    color: #242559;
    background-color: white;
    outline: none;
    border-width: 1px;
  }
  
  .e-btn.e-outline.left {
    border-right: transparent;
  }
  
  .e-btn.e-outline.right {
    border-left: transparent;
  }
  
  .e-btn.e-outline.active {
    box-shadow: none;
    color: #fff;
    background-color: #242559;
  }
  
  .e-input-group {
    border: 1px solid !important;
    border-width: 1px !important;
    background: #fff !important;
    font-size: 1rem !important;
    line-height: 1.25 !important;
    border-color: #d2ddec !important;
    color: #666666 !important;
    border-radius: 0.375rem !important;
    height: 2.5rem;
  }
  
  .c-drop-down {
    padding: 0.5rem 0.5rem !important;
  }
  
  .e-dropdownbase .e-list-item,
  .e-dropdownbase .e-list-item.e-item-focus,
  .e-dropdownbase .e-list-item.e-item-focus,
  .e-dropdownbase .e-list-item.e-active,
  .e-dropdownbase .e-list-item.e-active.e-hover,
  .e-dropdownbase .e-list-item.e-hover {
    background-color: #fff;
    color: #666666;
  }
  
  .e-input-group:not(.e-float-icon-left):not(.e-float-input)::before,
  .e-input-group:not(.e-float-icon-left):not(.e-float-input)::after,
  .e-input-group.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::before,
  .e-input-group.e-float-icon-left:not(.e-float-input) .e-input-in-wrap::after,
  .e-input-group.e-control-wrapper:not(.e-float-icon-left):not(
      .e-float-input
    )::before,
  .e-input-group.e-control-wrapper:not(.e-float-icon-left):not(
      .e-float-input
    )::after,
  .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-float-input)
    .e-input-in-wrap::before,
  .e-input-group.e-control-wrapper.e-float-icon-left:not(.e-float-input)
    .e-input-in-wrap::after {
    background: none;
  }
  
  .export-button {
    height: 2.5rem;
  }
  
  .button-line-divider {
    padding-left: 1rem;
    height: 2rem;
    width: 10%;
  }
  
  .e-grid .e-headercell {
    border-bottom-color: #dee2e6;
    border-top-color: #dee2e6;
    color: #212529;
    background: #f0f0f0;
    font-weight: 500;
    .e-headercelldiv {
      .e-header-text {
        font-weight: 600;
      }
    }
  }
  
  .e-popup .e-footer-content .e-btn.e-flat.e-flmenu-okbtn,
  .e-popup .e-footer-content .e-btn.e-flat.e-primary {
    background-color: #9f216d;
    border-color: #9f216d;
    color: #fff;
  }
  
  .e-popup .e-footer-content .e-btn.e-flat {
    background-color: #fff;
    color: #000;
    border-color: #7f7fcc;
  }
  
  #associatedcampaignsgrid .e-spinner-pane {
    display: none !important;
  }
  
  .cendyn-grid.e-grid .e-gridheader .e-sortfilter .e-headercell .e-headercelldiv .e-headertext,
  .e-grid .e-rowcell {
    font-size: 14px;
  }
  
  // Updating syncfusion icon
  #associatedCampaignsContent > div > div.col-md-2.float-left > div > span > span::before {
    content: '\e652' !important;
    font-family: 'e-icons';
    color: black;
    transform: none !important;
  }
  
  
  .e-dropdownbase .e-list-item.e-hover{
    background-color: #666 !important;
    border-color: #fff;
    color: white !important;
  }
  
  .e-ddl.e-input-group.e-control-wrapper .e-ddl-icon::before{
    transform: none !important;
  }
  </style>
  